<template>
  <el-card shadow="never">
    <el-card shadow="never">
      <el-transfer
        style="text-align: left; display: inline-block"
        :titles="titles"
        :data="facilities"
        :right-default-checked="selectedFacilities"
        v-model="selectedFacilities"
        @change="() => this.$emit('selected', selectedFacilities)"
      >
      </el-transfer>
    </el-card>
    <el-button @click="() => selectFacilityPreset(losAngelesArea)">Los Angeles Area</el-button>
    <el-button @click="() => selectFacilityPreset(orangeCounty)">Orange County</el-button>
    <el-button @click="() => selectFacilityPreset(sanFranciscoBayArea)" >San Francisco Bay Area</el-button>
    <el-button @click="() => selectFacilityPreset(seattleArea)">Seattle Area</el-button>
    <el-button @click="() => selectFacilityPreset(houstonArea)">Houston Area</el-button>
    <el-button @click="() => selectFacilityPreset(northernNJArea)">Northern New Jersey</el-button>
  </el-card>
</template>

<script>
import { getLocations } from '../utils/commonApi';

export default {
  name: 'LocationPicker',
  data() {
    return {
      facilities: [],
      selectedFacilities: [],
      titles: ['Facilities', 'Applied Facilities'],
      losAngelesArea: ['Northridge', 'LA Downtown', 'LA Gardena', 'South Gate'],
      orangeCounty: ['Anaheim', 'Santa Ana'],
      sanFranciscoBayArea: ['Richmond', 'Hayward', 'San Jose', 'Santa Clara', 'South SF Spruce', 'South SF Harris'],
      seattleArea: ['Renton', 'Southcenter', 'Redmond'],
      houstonArea: ['Houston East of Dtwn', 'Houston The Heights'],
      northernNJArea: ['Kearny', 'Saddle Brook', 'North Bergen']
    };
  },
  async mounted() {
    const response = await getLocations(this.$keycloak.token);
    this.facilities = response.map(fac => ({ key: fac._id, label: fac.title }));
    // await this.getUnits();
    this.loading = false;
  },
  methods: {
    selectFacilityPreset(preset) {
      // console.log(this.facilities.filter( facility => preset.includes(facility.title)).map(facility => facility._id));
      const filterLocations = [];
      for (const locationTitle of preset) {
        const [foundFilter] = this.facilities.filter( facility => locationTitle === facility.label);

        if (foundFilter) {
          filterLocations.push(foundFilter.key);
        }
      }
      this.selectedFacilities = filterLocations;

      this.$emit('selected', this.selectedFacilities);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LocationPicker.vue